import SignInForm from "@/app/signin/sign-in-form";

import AuthWrapperFour from "../shared/auth-layout/auth-wrapper-four";

// export const metadata = {
//   ...metaObject('Sign In'),
// };

export default function SignIn() {
    return (
        <AuthWrapperFour  title="Sign In" isSignIn isSocialLoginActive={false}>
            <SignInForm />
        </AuthWrapperFour>
    );
}
